import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import '@/scss/app.scss'

var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})

import Utils from '@/classes/Utils'
const utils = new Utils(process.env.VUE_APP_IS_DEBUG)

import Api from '@/classes/Api'
const api = new Api()

import Auth from '@/classes/Auth'
const auth = new Auth()

import Consts from '@/classes/Consts'
const consts = new Consts()

Vue.prototype.$utils = utils
Vue.prototype.$api = api
Vue.prototype.$auth = auth
Vue.prototype.$consts = consts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
